import { render, staticRenderFns } from "./BillList.vue?vue&type=template&id=b4761e08&scoped=true&"
import script from "./BillList.vue?vue&type=script&lang=js&"
export * from "./BillList.vue?vue&type=script&lang=js&"
import style0 from "./BillList.vue?vue&type=style&index=0&id=b4761e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4761e08",
  null
  
)

export default component.exports